(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["calculadora-envio"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('calculadora-envio')) {
    const STORAGE_KEY = 'alcazar:cp';

    class CalculadoraEnvio extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input');
        this.output = this.querySelector('.calc-envio__resultado');
        if (!this.form || this.dataset.ready) return;
        this.dataset.ready = 'true';

        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.calcular(true);
        });
        this.input.addEventListener('input', () => {
          this.input.value = this.input.value.replace(/\D/g, '').slice(0, 5);
          if (this.input.value.length === 5) this.calcular(true);
        });

        this.aplicarPerfil();

        let guardado = '';
        try { guardado = localStorage.getItem(STORAGE_KEY) || ''; } catch (e) {}
        if (/^\d{5}$/.test(guardado)) {
          this.input.value = guardado;
          this.calcular(false);
        }
      }

      // Si el producto pertenece a un "Perfil de envío", sus precios
      // reemplazan los de las zonas (en el mismo orden).
      aplicarPerfil() {
        const perfil = this.querySelector('[data-perfil]');
        if (!perfil) return;
        const precios = (perfil.dataset.precios || '').split('|');
        let hayGratis = false;

        this.querySelectorAll('[data-zona]').forEach((el, i) => {
          const [tarifa, ...resto] = (precios[i] || 'cotizar:').split(':');
          const precio = resto.join(':');
          el.dataset.tarifa = tarifa;
          el.dataset.precio = precio;
          const span = el.querySelector('.calc-envio__zona-precio');
          if (span) span.textContent = tarifa === 'gratis' ? 'Gratis' : tarifa === 'costo' ? precio : 'Cotizar';
          if (tarifa === 'gratis') hayGratis = true;
        });

        const subtitulo = this.querySelector('.calc-envio__subtitulo');
        if (subtitulo && perfil.dataset.subtitulo) subtitulo.textContent = perfil.dataset.subtitulo;

        // Sin zonas gratis: mostrar la lista completa con precios
        if (!hayGratis) {
          this.classList.add('calc-envio--todas');
          const summary = this.querySelector('.calc-envio__lista summary');
          if (summary) summary.textContent = summary.dataset.txtTodas;
        }
      }

      zonas() {
        return Array.from(this.querySelectorAll('[data-zona]')).map((el) => ({
          nombre: el.dataset.nombre,
          estados: el.dataset.estados,
          tarifa: el.dataset.tarifa,
          precio: el.dataset.precio,
          rangos: (el.dataset.prefijos || '')
            .split(',')
            .map((r) => r.trim())
            .filter(Boolean)
            .map((r) => {
              // "76" = un solo prefijo; "36-43" = rango
              const partes = r.split('-').map((n) => parseInt(n, 10));
              const a = partes[0];
              const b = partes.length > 1 && !Number.isNaN(partes[1]) ? partes[1] : a;
              return [a, b];
            })
            .filter(([a]) => !Number.isNaN(a)),
        }));
      }

      calcular(guardar) {
        const cp = this.input.value.trim();
        if (!/^\d{5}$/.test(cp)) {
          return this.mostrar('error', this.dataset.txtInvalido);
        }
        const prefijo = parseInt(cp.slice(0, 2), 10);
        const zona = this.zonas().find((z) => z.rangos.some(([a, b]) => prefijo >= a && prefijo <= b));

        if (guardar) {
          try { localStorage.setItem(STORAGE_KEY, cp); } catch (e) {}
        }
        if (!zona) return this.mostrar('error', this.dataset.txtNoEncontrado);

        if (zona.tarifa === 'gratis') {
          this.mostrar('gratis', this.dataset.txtGratis, zona.estados);
        } else if (zona.tarifa === 'costo') {
          this.mostrar('costo', (this.dataset.txtCosto || '').replace('[costo]', zona.precio), zona.estados);
        } else {
          this.mostrar('cotizar', this.dataset.txtCotizar, zona.estados);
        }
      }

      mostrar(tipo, principal, detalle) {
        this.output.hidden = false;
        this.output.dataset.tipo = tipo;
        this.output.textContent = '';
        const p = document.createElement('p');
        p.className = 'calc-envio__res-principal';
        p.textContent = principal;
        this.output.appendChild(p);
        if (detalle) {
          const d = document.createElement('p');
          d.className = 'calc-envio__res-detalle';
          d.textContent = 'Zona: ' + detalle;
          this.output.appendChild(d);
        }
      }
    }

    customElements.define('calculadora-envio', CalculadoraEnvio);
  }
  } catch(e) { console.error(e); }
})();

})();
